import Type from './Type.js'

class Dictionary {
    _options = {};
    _keyFields = null;
    _indexFields = null;
    _defaultKeyField = null;
    _keyMaps = {};
    _indexMaps = {};

    constructor(options, datas) {
        let keyFields = options.keyField;
        if (!keyFields) keyFields = ['code'];
        if (!Type.is(keyFields, Array)) keyFields = [keyFields];
        this._keyFields = keyFields;
        this._defaultKeyField = keyFields[0];

        this._indexFields = options.indexFields;
        this._options = options;
        if (datas) this.resetDatas(datas);
    }

    keyFields() {
        return this._keyFields;
    }

    defaultKeyField() {
        return this._defaultKeyField;
    }

    resetDatas(datas) {
        this._keyMaps = {};
        this._indexMaps = {};
        this.createDataMap(datas, this._keyFields, this._indexFields);
        // this.initKeyList(datas, this._defaultKeyField);
    }
    addData(data) {
        for (const keyField of this._keyFields) {
            this.createKeyMap(keyField, [data]);
        }
        if (this._indexFields) {
            for (const indexField of this._indexFields) {
                this.createIndexMap(indexField, [data]);
            }
        }
    }
    updateIndexMaps() {
        if (this._indexFields) {
            this._indexMaps = {};
            this.mapKey((data, key)=> {
                for (const indexField of this._indexFields) {
                    let map = this._indexMaps[indexField];
                    if (!map) map = this._indexMaps[indexField] = {};
                    const index = data[indexField];
                    let indexDatas = map[index];
                    if (!indexDatas) indexDatas = map[index] = {};
                    indexDatas[key] = 1;
                }
            })
        }
    }
    addDatas(datas) {
        for (const data of datas) {
            this.addData(data);
        }
    }
    updateData(key, data) {
        const d = this.getData(key);
        if (!d) this.addData(data);
        else {
            const o = Object.assign({}, data);
            delete o[this._defaultKeyField];
            Object.assign(d, o);
        }
    }
    updateDatas(datas) {
        this.createDataMap(datas, this._keyFields, this._indexFields);
        const keys = this.datasKeys(datas);
        return this.getDatas(keys);
    }
    resetIndexDatas(datas, indices, indexField) {
        this.removeIndexDatas(indices, indexField);
        this.updateDatas(datas);
    }
    // 建立主键-数据映射
    createKeyMap(keyField, datas) {
        if (!datas) return;
        let map = this._keyMaps[keyField];
        if (!map) map = this._keyMaps[keyField] = {};
        for (const data of datas) {
            if (!data) continue;
            map[data[keyField]] = data;
        }
    }

    // 建立索引-数据映射
    createIndexMap(indexField, datas) {
        if (!datas) return;
        let map = this._indexMaps[indexField];
        if (!map) map = this._indexMaps[indexField] = {};
        for (const data of datas) {
            if (!data) continue;
            const index = data[indexField];
            let indexDatas = map[index];
            if (!indexDatas) indexDatas = map[index] = {};
            indexDatas[this.dataKey(data)] = 1;
        }
    }
    createDataMap(datas, keyFields, indexFields) {
        for (const keyField of keyFields) {
            this.createKeyMap(keyField, datas);
        }
        if (indexFields) {
            for (const indexField of indexFields) {
                this.createIndexMap(indexField, datas);
            }
        }
    }

    addIndexField(indexField) {
        let map = this._indexMaps[indexField];
        if (map) return;
        map = this._indexMaps[indexField] = {};
        for (const [key, data] of Object.entries(this._keyMaps[this._defaultKeyField])) {
            const index = data[indexField];
            let indexDatas = map[index];
            if (!indexDatas) indexDatas = map[index] = {};
            indexDatas[this.dataKey(data)] = 1;
        }
    }

    testKeyField(keyField) {
        return this._keyMaps[keyField] != null;
    }
    testIndexField(indexField) {
        return this._indexMaps[indexField] != null;
    }

    getIndexMaps() {
        return this._indexMaps;
    }

    getIndexDatas(index, indexField) {
        const map = this._indexMaps[indexField];
        const keyMap = map[index];
        if (!keyMap) return null;
        return this.getDatasByKeyMap(keyMap);
    }

    dataKey(data, keyField) {
        return data ? data[keyField || this._defaultKeyField] : null;
    }
    datasKeys(datas, keyField) {
        if (!datas) return [];
        const keys = [];
        for (const data of datas) {
            keys.push(this.dataKey(data, keyField));
        }
        return keys;
    }
    getData(key, keyField) {
        const map = this._keyMaps[keyField || this._defaultKeyField];
        if (!map || !map[key]) {
            // console.log('data is not exists', keyField, key);
        }
        return map ? map[key] || null : null;
    }
    getDatas(keys, keyField) {
        if (!keys) return [];
        const datas = [];
        for (const key of keys) {
            const data = this.getData(key, keyField);
            if (!data) continue;
            datas.push(data);
        }
        return datas;
    }
    getIndicesDatas(indices, indexField) {
        let keyMap = {};
        const map = this._indexMaps[indexField];
        for (const index of indices) {
            const kMap = map[index];
            keyMap = Object.assign(keyMap, kMap);
        }
        return this.getDatasByKeyMap(keyMap);
    }

    getDatasByKeyMap(keyMap, keyField) {
        const datas = [];
        for (const key in keyMap) {
            datas.push(this.getData(key, keyField));
        }
        return datas;
    }

    unusedKeys(keys, keyField) {
        const map = this._keyMaps[keyField || this._defaultKeyField];
        if (!map) return keys;
        const unused = [];
        for (const key of keys) {
            if (key == null) continue;
            if (map[key] == null) {
                unused.push(key);
            }
        }
        return unused;
    }

    mapKey(proc, keyField) {
        const map = this._keyMaps[keyField || this._defaultKeyField];
        if (!map) return;
        for (const [value, data] of Object.entries(map)) {
            proc(data, value);
        }
    }
    mapIndex(proc, indexField) {
        const map = this._indexMaps[indexField];
        for (const [value, keyMap] of Object.entries(map)) {
            proc(keyMap, value);
        }
    }
    mapAll(proc) {
        this.mapKey(proc);
    }

    removeByKeys(keys) {
        for (const key of keys) {
            const data = this.getData(key);
            for (const keyField of this._keyFields) {
                const k = data[keyField];
                const keyMap = this._keyMaps[keyField];
                delete keyMap[k];
            }
            for (const indexField of this._indexFields) {
                const index = data[indexField];
                const indexMap = this._indexMaps[indexField][index];
                if (indexMap) delete indexMap[key];
            }
        }
    }
    removeByKeyMap(keyMap) {
        for (const key in keyMap) {
            const data = this.getData(key);
            for (const keyField of this._keyFields) {
                const k = data[keyField];
                const keyMap = this._keyMaps[keyField];
                delete keyMap[k];
            }
            for (const indexField of this._indexFields) {
                const index = data[indexField];
                const indexMap = this._indexMaps[indexField][index];
                if (indexMap) delete indexMap[key];
            }
        }
    }
    removeByDatas(datas) {
        for (const data of datas) {
            const key = this.dataKey(data);
            for (const keyField of this._keyFields) {
                const k = data[keyField];
                const keyMap = this._keyMaps[keyField];
                delete keyMap[k];   
            }
            for (const indexField of this._indexFields) {
                const index = data[indexField];
                const indexMap = this._indexMaps[indexField][index];
                if (indexMap) delete indexMap[key];
            }
        }
    }
    removeIndexDatas(indices, indexField) {
        // console.log('remove index datas', indexField, indices);
        if (!(indices instanceof Array)) indices = [indices];
        const indexMap = this._indexMaps[indexField];
        if (!indexMap) return;
        let keyMap = {};
        for (const index of indices) {
            const kMap = indexMap[index];
            if (kMap) {
                keyMap = Object.assign(keyMap, kMap);
                delete indexMap[index];
            }
        }
        this.removeByKeyMap(keyMap);
    }

    gc() {

    }

}

export default Dictionary;